import Base from '@studiometa/js-toolkit';

/**
 * ProductGallery component
 */
export default class ProductGallery extends Base {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'ProductGallery',
    };
  }

  /**
   * Thumbnail button
   */
  onBtnClick(event, index) {
    this.$refs.thumbnail.forEach((element) => {
      element.classList.remove('is-visible');
    });

    this.$refs.thumbnail[index].classList.add('is-visible');
  }
}
